import { Box, Button } from '@mui/material';
import { Dialog } from '@peritasai/ui-components';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface DetailsDialogProps {
  open: boolean;
  isEditing: boolean;
  title: string;
  saveLabel: string;
  saveTestId: string;
  saveDisabled?: boolean;
  onSave: () => void;
  onClose: () => void;
  children: ReactNode;
}

/** Dialog frame shared by the note and instrument-details dialogs: add/edit title, save button, field layout. */
export const DetailsDialog = ({
  open,
  isEditing,
  title,
  saveLabel,
  saveTestId,
  saveDisabled = false,
  onSave,
  onClose,
  children,
}: DetailsDialogProps) => {
  const { t } = useTranslation(['periverse']);

  return (
    <Dialog
      open={open}
      title={`${isEditing ? t('common.edit') : t('common.add')} ${title}`}
      onClose={onClose}
      footer={
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            data-testid={saveTestId}
            variant="contained"
            onClick={onSave}
            disabled={saveDisabled}
            sx={{ borderRadius: '24px', width: 150 }}
          >
            {saveLabel}
          </Button>
        </Box>
      }
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>{children}</Box>
    </Dialog>
  );
};
